import { Injectable, signal } from '@angular/core';
import { ReportFilterType } from '../../utils/report-row.helper';

export const reportsPanelSelectedTypeStorageKey =
  'rollout-progress-reports-panel-selected-type';
export const reportsPanelHideCompletedStorageKey =
  'rollout-progress-reports-panel-hide-completed';

@Injectable({ providedIn: 'root' })
export class ReportsPanelStateService {
  readonly selectedReportType = signal<ReportFilterType | null>(
    localStorage.getItem(
      reportsPanelSelectedTypeStorageKey,
    ) as ReportFilterType | null,
  );
  readonly hideCompletedReports = signal(
    localStorage.getItem(reportsPanelHideCompletedStorageKey) !== 'false',
  );

  setSelectedReportType(type: ReportFilterType): void {
    this.selectedReportType.set(type);
    localStorage.setItem(reportsPanelSelectedTypeStorageKey, type);
  }

  setHideCompletedReports(hideCompleted: boolean): void {
    this.hideCompletedReports.set(hideCompleted);
    localStorage.setItem(
      reportsPanelHideCompletedStorageKey,
      String(hideCompleted),
    );
  }
}
